import { render, staticRenderFns } from "./ed-homework-widget-course.vue?vue&type=template&id=214a577b&scoped=true&"
import script from "./ed-homework-widget-course.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-widget-course.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-widget-course.scss?vue&type=style&index=0&id=214a577b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a577b",
  null
  
)

export default component.exports